import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    Typography,
    Tooltip,
} from "@mui/material";

import CENTAvatar from "../CENTAvatar";
import RenderDate from "../../../Common/Date/RenderDate";

import { linkBuilder } from "./TaskFunctions";

function TaskCard({ task, owner = null }) {
    const location = useLocation();
    const refererPath = encodeURIComponent(location.pathname);

    const title = task?.title?.length > 0 ? task.title : "Task";

    const description =
        task?.description?.length > 0 ? task.description : "No description";

    const resource = task?.resource ?? {};
    const resourceType = resource?.type?.length > 0 ? resource.type : "task";
    const resourceOwner = resource?.owner?.length > 0 ? resource.owner : null;
    const external = resourceOwner && owner && resourceOwner !== owner;

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={linkBuilder(resource, owner, refererPath)}
                centerRipple={false}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="Go to task" arrow>
                            <CENTAvatar
                                type={resourceType}
                                badge={external ? "person" : ""}
                            />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            {title}
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            <RenderDate date={task?.date} />
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body2">{description}</Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default TaskCard;
